export default __webpack_public_path__ + "static/pic2-caad087bdb8b341563431a2c016f02ae.jpeg";